import tsParser from "@typescript-eslint/parser";
import type { PluginTwoslashOptions } from "./types.ts";

export const instanceConfigsDefaults: PluginTwoslashOptions["instanceConfigs"] = {
	twoslash: {
		explicitTrigger: true,
		languages: ["ts", "tsx", "vue"],
	},
	eslint: {
		explicitTrigger: true,
		languages: ["ts", "tsx"],
	},
};

export const twoslashEslintDefaults: PluginTwoslashOptions["twoslashEslintOptions"] = {
	eslintConfig: [
		{
			files: ["**"],
			rules: {
				"constructor-super": ["error"],
				"for-direction": ["error"],
				"getter-return": ["error"],
				"no-async-promise-executor": ["error"],
				"no-case-declarations": ["error"],
				"no-class-assign": ["error"],
				"no-compare-neg-zero": ["error"],
				"no-cond-assign": ["error"],
				"no-const-assign": ["error"],
				"no-constant-binary-expression": ["error"],
				"no-constant-condition": ["error"],
				"no-control-regex": ["error"],
				"no-debugger": ["error"],
				"no-delete-var": ["error"],
				"no-dupe-args": ["error"],
				"no-dupe-class-members": ["error"],
				"no-dupe-else-if": ["error"],
				"no-dupe-keys": ["error"],
				"no-duplicate-case": ["error"],
				"no-empty": ["error"],
				"no-empty-character-class": ["error"],
				"no-empty-pattern": ["error"],
				"no-empty-static-block": ["error"],
				"no-ex-assign": ["error"],
				"no-extra-boolean-cast": ["error"],
				"no-fallthrough": ["error"],
				"no-func-assign": ["error"],
				"no-global-assign": ["error"],
				"no-import-assign": ["error"],
				"no-invalid-regexp": ["error"],
				"no-irregular-whitespace": ["error"],
				"no-loss-of-precision": ["error"],
				"no-misleading-character-class": ["error"],
				"no-new-native-nonconstructor": ["error"],
				"no-nonoctal-decimal-escape": ["error"],
				"no-obj-calls": ["error"],
				"no-octal": ["error"],
				"no-prototype-builtins": ["error"],
				"no-redeclare": ["error"],
				"no-regex-spaces": ["error"],
				"no-self-assign": ["error"],
				"no-setter-return": ["error"],
				"no-shadow-restricted-names": ["error"],
				"no-sparse-arrays": ["error"],
				"no-this-before-super": ["error"],
				"no-unassigned-vars": ["error"],
				"no-undef": ["error"],
				"no-unexpected-multiline": ["error"],
				"no-unreachable": ["error"],
				"no-unsafe-finally": ["error"],
				"no-unsafe-negation": ["error"],
				"no-unsafe-optional-chaining": ["error"],
				"no-unused-labels": ["error"],
				"no-unused-private-class-members": ["error"],
				"no-unused-vars": ["error"],
				"no-useless-assignment": ["error"],
				"no-useless-backreference": ["error"],
				"no-useless-catch": ["error"],
				"no-useless-escape": ["error"],
				"no-with": ["error"],
				"preserve-caught-error": ["error"],
				"require-yield": ["error"],
				"use-isnan": ["error"],
				"valid-typeof": ["error"],
			},
			languageOptions: {
				parserOptions: {
					ecmaFeatures: {
						jsx: true,
					},
					sourceType: "module",
				},
				ecmaVersion: "latest",
				parser: tsParser,
			},
		},
	],
};
